import React ,{useEffect} from 'react';
import Footer from '../../../components/Footer';
import Header from '../../../components/Header';
import PartnersMain from './PartnersMain';

const Partners = () => {
    useEffect(() => {
        document.title = "Strategic Partners | Society of Aquaculture Professionals";
      }, []);
  return (
    <div>
      <>
        <Header />

        <PartnersMain />

        <Footer />
      </>
    </div>
  );
};
export default Partners;
